import { ApiVersion } from '@/config';
import { INCICSearchRequest } from '@/models';
import { NCICRequestRecord } from '@/pages/NCIC/data';

import { http } from './http';
import { ApiResponse, IGetParams, IPaginatedListResponse } from './types';

// UPDATE This file to include the correct API endpoints and types for NCIC search requests
// /request - header x-device-uid

const sendRequest = (values: any, deviceUid: string) => {
  return http.post<ApiResponse<any>>(
    `api/${ApiVersion.V1}/ncic/request`,
    values,
    {
      headers: {
        'X-DEVICE-UID': deviceUid,
      },
    },
  );
};

const getHistory = () => {
  return http.get<NCICRequestRecord[]>(`api/${ApiVersion.V1}/ncic`);
};

const getNCICSearchApprovals = (params?: IGetParams) => {
  return http.get<IPaginatedListResponse<INCICSearchRequest[]>>(
    `api/${ApiVersion.V1}/ncic/approvals`,
    {
      params,
    },
  );
};

const getNCICSearchApproval = (id: string) => {
  return http.get<ApiResponse<INCICSearchRequest>>(
    `api/${ApiVersion.V1}/ncic/approvals/${id}`,
  );
};

const createNCICSearchApproval = (data: { deviceUID: string }) => {
  return http.post<{ deviceUID: string }, ApiResponse<INCICSearchRequest>>(
    `api/${ApiVersion.V1}/ncic/approvals`,
    data,
  );
};

const approveNCICSearchApproval = (
  id: string,
  data: { oriNumber: string; mnemonic: string },
) => {
  return http.post<
    { oriNumber: string; mnemonic: string },
    ApiResponse<INCICSearchRequest>
  >(`api/${ApiVersion.V1}/ncic/approvals/${id}/approve`, data);
};

const rejectNCICSearchApproval = (id: string) => {
  return http.post<ApiResponse<INCICSearchRequest>>(
    `api/${ApiVersion.V1}/ncic/approvals/${id}/reject`,
  );
};

export const NCICApi = {
  sendRequest,
  getHistory,
  getNCICSearchApprovals,
  getNCICSearchApproval,
  createNCICSearchApproval,
  approveNCICSearchApproval,
  rejectNCICSearchApproval,
};
